import { AccountListsV2, useAccountListsV2 } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';

export function Lists() {
  const { data: lists, isLoading } = useAccountListsV2();

  useEffect(() => {
    document.title = 'Report Lists - NumberGuru';
  }, []);

  return (
    <AccountListsV2
      lists={lists || []}
      isLoading={isLoading}
      hideContactProExport={true}
    />
  );
}
